@if (!displayData?.length) {
<div class="no-content">{{ 'DIALOGS.NO_RECORDS' | translate }}</div>
} @else {
<div class="history-header">
  @if (data.type && customHeaderTypes.includes(data.type)) { @if (data.type === 'contract') {
  <div>{{ 'ADMIN.DEVICES.ON_CONTRACT_TILL' | translate }}</div>
  } @if (data.type === 'clientContract') {
  <div>{{ 'DIALOGS.HISTORY.CONTRACT_DURATION' | translate }}</div>
  } @if (data.type === 'device.phone.changed') {
  <div>{{ 'DIALOGS.HISTORY.PHONE_NUMBER' | translate }}</div>
  } } @else {
  <div>{{ 'DIALOGS.STATUS' | translate }}</div>
  }
  <div>{{ 'DIALOGS.DATE' | translate }}</div>
  <div>{{ 'DIALOGS.USER' | translate }}</div>
</div>
<div linPerfectScrollbar class="history-container">
  @for (status of displayData; track $index) {
  <div class="history-info">
    @if (data.type && customDataTypes.includes(data.type)) { @if (data.type === 'contract') {
    <div>{{ status.payload | dayjsDate }}</div>
    } @if (data.type === 'unavailable') {
    <div>{{ (status.payload ? 'DIALOGS.HISTORY.UNAVAILABLE' : 'DIALOGS.HISTORY.ENABLED') | translate }}</div>
    } @if (data.type === 'deactivated') {
    <div>{{ (status.payload ? 'DIALOGS.HISTORY.DEACTIVATED' : 'DIALOGS.HISTORY.ACTIVATED') | translate }}</div>
    } } @else {
    <div>{{ status.payload }}</div>
    }
    <div>{{ status.createdAt | dayjsDateTime }}</div>
    <div>{{ status.createdByName }}</div>
    <mat-divider></mat-divider>
  </div>
  }
</div>
<lin-table-toolbar>
  @if (isShowPagination) {
  <mat-paginator #paginator [length]="total" (page)="onPageChange($event)" linPaginatorDefault></mat-paginator>
  }
</lin-table-toolbar>
}
